import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Input } from 'reactstrap'
import { updateWidget, removeWidget } from './WidgetUtils'

class WidgetModal extends Component {
  constructor (props) {
    super(props)

    const { node } = this.props

    const attributes = node.data.toJS()

    const isValidYoutubeURL = this.isValidYoutubeURL(attributes.url)
    const isValidMP4URL = this.isValidMP4URL(attributes.url)

    this.state = {
      attributes: {
        ...attributes
      },
      isValidYoutubeURL,
      isValidMP4URL,
      isValidVideoURL: isValidYoutubeURL || isValidMP4URL,
      type: node.type,
      isEditing: true
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (!this.props.isOpen && nextProps.isOpen) {
      // the modal will be opened
      if (this.inputUrl) {
        this.inputUrl.focus()
      }
    }
  }

  componentDidMount () {
    if (this.inputUrl) {
      this.inputUrl.focus()
    }
  }

  setWidgetAttribute (attributeName, value) {
    const attributes = {
      ...this.state.attributes,
      [attributeName]: value
    }
    const _state = { attributes }
    this.setState(_state)
  }

  onKeyDown = (synthetic, event) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  isValidYoutubeURL = url => url && typeof url === 'string' && url.length &&
    (url.indexOf('youtu.be') > -1 || url.indexOf('youtube') > -1)

  isValidMP4URL = url => url && typeof url === 'string' && url.length &&
    (url.substring(url.length - 3).toLowerCase() === 'mp4')

  onChangeAttribute = (event) => {
    const isVideo = this.props.node.type === 'Video'
    const { name, value } = event.target
    let errors = {}

    if (isVideo && name === 'url') {
      errors = {
        isValidYoutubeURL: this.isValidYoutubeURL(value),
        isValidMP4URL: this.isValidMP4URL(value)
      }
      errors.isValidVideoURL = errors.isValidYoutubeURL || errors.isValidMP4URL
      if (!errors.isValidVideoURL) {
        // invalid
        event.target.setCustomValidity('Must be youtube or mp4 URL')
        return this.setState({ ...errors })
      }
    }

    event.target.setCustomValidity('')
    this.setState({ ...errors }, () => {
      this.setWidgetAttribute(name, value)
    })
  }

  toggle = () => {
    const isOpen = !this.props.isOpen
    if (isOpen) {
      return this.props.changeModalState(true)
    }
    this.onCancel()
  }

  onCancel = () => {
    const { node } = this.props
    if (!node.data.get('url')) this.props.onChange(removeWidget({state: this.props.state, key: node.key}))
    this.props.changeModalState(false)
    this.setState({isEditing: false})
  }

  onSubmit = e => {
    e.preventDefault()

    const { node } = this.props
    const isVideo = node.type === 'Video'
    const attributes = {...this.state.attributes}

    if (isVideo && !this.state.isValidVideoURL) {
      this.inputUrl.setCustomValidity('Video URL not valid')
      return this.inputUrl.reportValidity()
    }

    // close modal
    attributes.openModal = false

    if (!attributes.url) {
      this.props.onChange(removeWidget({state: this.props.state, key: node.key}))
    } else {
      this.props.onChange(updateWidget({ state: this.props.state, data: attributes, type: node.type }))
    }

    this.setState({attributes})

    this.props.changeModalState(false)
  }

  render () {
    const isVideo = this.state.type === 'Video'

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.toggle} size='lg' >
        <ModalHeader toggle={this.toggle}>Edit Widget</ModalHeader>
        <ModalBody onKeyDown={this.onKeyDown}>

          {/* Video url */}
          {isVideo &&
            <Form name='WidgetForm' style={{margin: '20px 0'}}>
              <FormGroup>
                <Input type='text' name='url' id='Widget-url' placeholder='e.g. https://www.youtube.com/watch?v=IK2IFIrrcPU'
                  onClick={e => e.stopPropagation()}
                  onChange={this.onChangeAttribute}
                  defaultValue={this.state.attributes.url}
                  getRef={input => { this.inputUrl = input }}
                  valid={this.state.isValidVideoURL}
                  autoFocus
                   />
                {
                  !this.state.isValidVideoURL &&
                  <div style={{marginTop: '4px'}}>
                    <ul>
                      {
                        !this.state.isValidYoutubeURL &&
                        <li>Not a valid youtube URL.</li>
                      }
                      {
                        !this.state.isValidMP4URL &&
                        <li>Not a valid mp4 URL (should end in <code>.mp4</code>).</li>
                      }
                    </ul>
                  </div>
                }
              </FormGroup>
            </Form>
          }

          {false &&
            <div className='debug-block'>
              state
              <pre>{JSON.stringify(this.state, null, 4)}</pre>
              props.presetData
              <pre>{JSON.stringify(this.props.presetData, null, 4)}</pre>
              props.node.data
              <pre>{JSON.stringify(this.props.node.get('data'), null, 4)}</pre>
            </div>
          }

        </ModalBody>
        <ModalFooter>
          <Button form='WidgetForm' color='primary' type='submit' onClick={this.onSubmit}>Save</Button>{' '}
          <Button form='WidgetForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

WidgetModal.propTypes = {
  isOpen: PropTypes.bool,
  node: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.shape({
      get: PropTypes.func.isRequired
    }),
    get: PropTypes.func.isRequired
  }),
  state: PropTypes.object.isRequired,
  changeModalState: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  presetData: PropTypes.shape({
    text: PropTypes.string
  })
}

export default WidgetModal



// WEBPACK FOOTER //
// ./src/components/WidgetSlatePlugin/WidgetModal.js